import { Group, Stack } from '@mantine/core';
import { IconReportAnalytics } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { PortalButton } from '../components/PortalButton';
import { PortalEmptyState } from '../components/PortalEmptyState';
import { PortalPageHeader } from '../components/PortalPageHeader';

/**
 * What /portal/bookkeeping and /portal/reports show while the portal does not
 * offer them (see config/portalFeatures.ts). It makes no request: there is
 * nothing to load, and nothing here can fail or sign the customer out.
 */
export default function PortalBookkeepingUnavailablePage() {
  const navigate = useNavigate();
  return (
    <Stack gap='md' data-testid='portal-bookkeeping-unavailable'>
      <PortalPageHeader title='Bookkeeping and reports' backLink='/portal/dashboard' />
      <PortalEmptyState
        icon={<IconReportAnalytics size={32} />}
        title='Bookkeeping and reports are not available in the portal'
        description='Your accountant prepares your bookkeeping and financial reports. Message them and they will send you a copy.'
      />
      <Group justify='center' gap='sm' px='md'>
        <PortalButton
          data-testid='portal-bookkeeping-unavailable-chat'
          onClick={() => void navigate({ to: '/portal/chat' })}
        >
          Message your accountant
        </PortalButton>
        <PortalButton
          variant='default'
          data-testid='portal-bookkeeping-unavailable-dashboard'
          onClick={() => void navigate({ to: '/portal/dashboard' })}
        >
          Back to dashboard
        </PortalButton>
      </Group>
    </Stack>
  );
}
